import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-login',
    templateUrl: './recover-password.component.html',
    styleUrls: ['../../login.component.scss'],
    standalone: false
})
export class RecoverPasswordComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
